import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { USER_API } from "../../common/common";
import { getDomain, getImageUrl } from "../../common/Funcation";
import { getApi } from "../../service";

const HomePromoSlider = () => {
  const dispatch = useDispatch();
  const homeData = useSelector((e: any) => e.homeData);
  const banners = Array.isArray(homeData?.bannersInfo) ? homeData.bannersInfo : [];
  const [bannerLoaded, setBannerLoaded] = useState(false);

  useEffect(() => {
    if (banners.length > 0) return;
    let cancelled = false;
    const domainName = getDomain();
    getApi({
      api: `${USER_API.HOME}?domain=${domainName}`,
      value: { domain: domainName },
    })
      .then((response: any) => {
        if (cancelled || !response?.data?.data) return;
        dispatch({ type: "SET_HOME_DATA", payload: response.data.data });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [banners.length, dispatch]);

  return (
    <>
    {banners.length > 0 && (
    <div
      className={`home_wrp_promobanner ${bannerLoaded ? "banner-loaded" : "banner-loading"}`}
      style={{ width: "100%", aspectRatio: "1132/211", overflow: "hidden" }}
    >
      <Slider
        dots={true}
        infinite={true}
        autoplay={true}
        autoplaySpeed={5000}
        speed={1000}
        arrows={true}
        slidesToShow={1}
        slidesToScroll={1}
      >
        {banners.map((item: any, idx: number) => (
          <div key={item.id || item._id || idx}>
            <img
              src={getImageUrl(item.image)}
              alt="promobanner"
              loading={idx === 0 ? "eager" : "lazy"}
              decoding="async"
              onLoad={() => setBannerLoaded(true)}
            />
          </div>
        ))}
      </Slider>
    </div>
    )}
    </>
  );
};

export default HomePromoSlider;
